module.exports = __webpack_public_path__ + "media/images/logo-bfbb990da86d4e8ee22345c6acac3695.svg";